/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Form, Input, Select } from 'antd';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';
import { EditableContext } from './MapsInstrumetnTable';
import CustomInputNumber from '../../../components/CustomInputNumber/CustomInputNumber';
import { textSort } from '../../../helpers/textSort';

const EditableCell = ({
  title,
  editing,
  children,
  dataIndex,
  record,
  handleSave,
  instrumentList,
  getInstrumentItem,
  MAPPING_TYPE,
  assets,
  ...restProps
}) => {
  const form = useContext(EditableContext);

  const weightFormatter = (value) => {
    if (value == null) return '';
    if (typeof value === 'object' && 'numerator' in value && 'denominator' in value) {
      const num = Number(value.numerator);
      const den = Number(value.denominator);
      if (den === 0) return '';
      return den === 1 ? String(num) : `${num}/${den}`;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed.includes('/')) {
        const [n, d] = trimmed.split('/').map((s) => Number(s.trim()));
        if (Number(d) === 0) return '';
        return Number(d) === 1 ? String(n) : `${n}/${d}`;
      }
      return trimmed;
    }
    return '';
  };

  useEffect(() => {
    if (dataIndex) {
      const raw = record[dataIndex];
      const value = ['weight_in', 'weight_out'].includes(dataIndex)
        ? weightFormatter(raw)
        : raw;
      form.setFieldsValue({
        [dataIndex]: value,
      });
    }
  }, [dataIndex, record]);

  const getWeight = (weit, type) => {
    if (typeof weit === 'string') {
      const num = weit.includes('/') ? Number(weit.split('/')[0]) : weit;
      const den = weit.includes('/') ? Number(weit.split('/')[1]) : 1;
      return type === 'in'
        ? { numIn: num, denIn: den }
        : type === 'out'
          ? { numOut: num, denOut: den }
          : { num, den };
    } else {
      return type === 'in'
        ? { numIn: weit.numerator, denIn: weit.denominator }
        : type === 'out'
          ? { numOut: weit.numerator, denOut: weit.denominator }
          : { numerator: weit.numerator, denominator: weit.denominator };
    }
  };

  const initValue = {
    asset_class_id: null,
    asset_id: null,
    group_no: null,
    prio: null,
    weight_in: '',
    weight_out: '',
  };

  const ensureWeightObjects = (data) => {
    const { numIn, denIn } = getWeight(data.weight_in, 'in');
    const { numOut, denOut } = getWeight(data.weight_out, 'out');
    return {
      ...data,
      weight_in: { numerator: +numIn, denominator: +denIn },
      weight_out: { numerator: +numOut, denominator: +denOut },
    };
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      console.log('🚀 ~ save ~ values:', values);
      const instrument = getInstrumentItem(values.asset_id);
      console.log('🚀 ~ save ~ instrument:', instrument);
      if (dataIndex === 'asset_id') {
        const newData = {
          ...record,
          ...values,
          isin: instrument?.isin,
          asset_class_id: instrument?.financialAssetID,
          group_no: record.prio === 10 ? instrument?.financialAssetID : null,
        };
        console.log('🚀 ~ save ~ newData:', newData);
        handleSave(ensureWeightObjects(newData));
      } else if (dataIndex === 'asset_class_id') {
        const data = {
          ...record,
          ...values,
          prio: 10,
          asset_id: null,
          group_no: values.asset_class_id,
        };
        console.log('🚀 ~ save ~ data:', data);
        handleSave(ensureWeightObjects({ ...data }));
      } else if (dataIndex === 'mapping_type') {
        const data = {
          ...record,
          ...values,
          ...initValue,
        };
        if(values.mapping_type === 'ONE-TO-ONE') {
          data.weight_in = {numerator: 1, denominator: 1};
          data.weight_out = {numerator: 1, denominator: 1};
        }
        if(values.mapping_type === 'INBOUND') {
          data.prio = 10;
          data.weight_in = {numerator: 1, denominator: 1};
          data.weight_out = {numerator: 0, denominator: 0};
        }
        if(values.mapping_type === 'OUTBOUND') {
          data.prio = 10;
          data.weight_in = {numerator: 0, denominator: 0};
          data.weight_out = {numerator: 1, denominator: 1};
        }
        handleSave(ensureWeightObjects({ ...data }));
        // form.setFieldsValue({ ...data, weight_in: 1, weight_out: 1 });
      } else if (dataIndex === 'prio') {
        if (record?.prio === 10) {
          const { numIn, denIn } = getWeight(record.weight_in, 'in');
          const { numOut, denOut } = getWeight(record.weight_out, 'out');
        const data = {
          ...record,
          ...values,
          group_no: instrument?.financialAssetID,
          weight_in: { numerator: +numIn, denominator: +denIn },
          weight_out: { numerator: +numOut, denominator: +denOut },
        };
        console.log('🚀 ~ save ~ data:', data);
        handleSave(ensureWeightObjects(data));
          // form.setFieldsValue({ ...data, weight_in: 1, weight_out: 1 });
        } else {
          const { numIn, denIn } = getWeight(record.weight_in, 'in');
          const { numOut, denOut } = getWeight(record.weight_out, 'out');
          const data = {
            ...record,
            ...values,
            group_no: null,
            weight_in: { numerator: +numIn, denominator: +denIn },
            weight_out: { numerator: +numOut, denominator: +denOut },
          };
          console.log('🚀 ~ save ~ data:', data);
          handleSave(ensureWeightObjects(data));
          // form.setFieldsValue({ ...data, weight_in: 1, weight_out: 1 });
        }
      } else if (dataIndex === 'weight_in') {
        const { numIn, denIn } = getWeight(values.weight_in, 'in');
        const { numOut, denOut } = getWeight(record.weight_out, 'out');
        const data = {
          ...record,
          ...values,
          weight_in: { numerator: +numIn, denominator: +denIn },
          weight_out: { numerator: +numOut, denominator: +denOut },
        };
        handleSave(ensureWeightObjects(data));
      } else if (dataIndex === 'weight_out') {
        const { numIn, denIn } = getWeight(record.weight_in, 'in');
        const { numOut, denOut } = getWeight(values.weight_out, 'out');
        const data = {
          ...record,
          ...values,
          weight_in: { numerator: +numIn, denominator: +denIn },
          weight_out: { numerator: +numOut, denominator: +denOut },
        };
        handleSave(ensureWeightObjects(data));
      } else {
        const { numIn, denIn } = getWeight(record.weight_in, 'in');
        const { numOut, denOut } = getWeight(record.weight_out, 'out');
        handleSave(ensureWeightObjects({
          ...record,
          ...values,
          weight_in: { numerator: +numIn, denominator: +denIn },
          weight_out: { numerator: +numOut, denominator: +denOut },
        }));
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

const assetsOptions = assets?.map(({ ID, name }) => ({ value: ID, label: name }));

  if (editing) {
    return (
      <>
        {dataIndex === 'mapping_type' && record?.key
        ? ( <td {...restProps}>
            <Form.Item
              style={{ margin: 0}}
              name={dataIndex} >
              <CustomSelect 
                className="custom-select" 
                width={'100%'} 
                options={MAPPING_TYPE} 
                onSelect={save} />
            </Form.Item>
          </td>
        )
        : dataIndex === 'operation' || dataIndex === 'mapping_type' && !record?.key
          ? <td {...restProps}>{children}</td>
          : ( ['asset_class_id', 'isin', 'currency_id','weight_in',
          'weight_out'].includes(dataIndex)) && record.mapping_type === 'ONE-TO-ONE'
            ? <td {...restProps}>{children}</td>
            : record.mapping_type === 'ONE-TO-ONE' && dataIndex === 'asset_id'
              ? (
                <td {...restProps}>
                  <Form.Item
                  style={{
                    margin: 0,
                  }}
                  name={dataIndex}
                >
                  <CustomSelect
                    showSearch
                    width="300px"
                    className="custom-select"
                    onSelect={save}
                    placeholder={record[title]}
                    filterOption={(inputValue, option) => {
                      return inputValue.length > 2
                        ? option.children?.props?.children
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                        : true;
                    }}
                    notFoundContent={<></>}
                  >
                    {instrumentList
                      ?.slice()
                      ?.sort((a, b) => textSort(a.name, b.name))
                      ?.map(({ ID, name }) => (
                        <Select.Option key={ID} value={ID}>
                          {name}
                        </Select.Option>
                      ))}
                  </CustomSelect>
                  </Form.Item>
              </td>
              )
              : dataIndex === 'prio' && record.asset_id && record.mapping_type !== 3
              ? 
                <td>
                  <Form.Item
                    style={{
                      margin: 0,
                    }}
                    name={dataIndex}
                  >
                    <CustomInputNumber
                      className="custom-inputnumber"
                      style={{ width: '100%' }}
                      min={1}
                      max={10}
                      step={1}
                      onBlur={save}
                      onChange={save}
                      onStep={save}
                      onPressEnter={save}
                      placeholder={record[dataIndex]}
                      controls={false}
                    />
                  </Form.Item>
                </td>
              : record?.prio === 10 && dataIndex === 'group_no'
              ? (
                <td>
                  <Form.Item
                    style={{
                      margin: 0,
                    }}
                    name={dataIndex}
                  >
                    <CustomInputNumber
                      className="custom-inputnumber"
                      style={{ width: '100%' }}
                      min={1}
                      step={1}
                      onBlur={save}
                      onChange={save}
                      onStep={save}
                      onPressEnter={save}
                      placeholder={record[dataIndex]}
                      defaultValue={record.asset_class_id}
                      controls={false}
                    />
                  </Form.Item>
                </td>
              )
              : record.mapping_type === 'INBOUND'
                ? dataIndex === 'asset_class_id'
                  ? (
                    <td {...restProps}>
                      <Form.Item
                        style={{
                          margin: 0,
                        }}
                        name={dataIndex}
                      >
                        <CustomSelect 
                          className="custom-select" 
                          width={'100%'} 
                          options={assetsOptions} 
                          onSelect={save} />
                      </Form.Item>
                    </td>
                  )
                  : dataIndex === 'prio' || dataIndex === 'weight_out'
                    ? (
                      <td {...restProps}>{children}</td>
                    )
                    : dataIndex === 'weight_in'
                      ? <td>
                        <Form.Item
                          style={{
                            margin: 0,
                          }}
                          name={dataIndex}
                        >
                        <Input
                          className="custom-input full-width"
                          style={{ width: '100%', maxWidth: '100px' }}
                          onBlur={save}
                          placeholder={record[title]}
                        />
                        </Form.Item>
                      </td>
                      : <td></td>
                : record.mapping_type === 'OUTBOUND'
                  ? dataIndex === 'asset_id'
                  ? (
                    <td {...restProps}>
                      <Form.Item
                        style={{
                          margin: 0,
                        }}
                        name={dataIndex}
                      >
                        <CustomSelect
                          showSearch
                          width="300px"
                          className="custom-select"
                          onSelect={save}
                          placeholder={record[title]}
                          filterOption={(inputValue, option) => {
                            return inputValue.length > 2
                              ? option.children?.props?.children
                                  .toUpperCase()
                                  .indexOf(inputValue.toUpperCase()) !== -1
                              : true;
                          }}
                          notFoundContent={<></>}
                        >
                          {instrumentList
                            ?.slice()
                            ?.sort((a, b) => textSort(a.name, b.name))
                            ?.map(({ ID, name }) => (
                              <Select.Option key={ID} value={ID}>
                                {name}
                              </Select.Option>
                            ))}
                        </CustomSelect>
                      </Form.Item>
                    </td>
                  )
                  : ['prio', 'weight_in', 'isin', 'currency_id', 'asset_class_id'].includes(dataIndex)
                    ? (
                      <td {...restProps}>{children}</td>
                    )
                    : dataIndex === 'weight_out'
                      ? <td>
                        <Form.Item
                          style={{
                            margin: 0,
                          }}
                          name={dataIndex}
                        >
                        <Input
                          className="custom-input full-width"
                          style={{ width: '100%', maxWidth: '100px' }}
                          onBlur={save}
                          placeholder={record[title]}
                        />
                        </Form.Item>
                      </td>
                      : <td></td>
                  : <td></td>
        }
              
      </>
    );
  } else {
    return <td {...restProps}>{children}</td>;
  }
};

export default EditableCell;

EditableCell.propTypes = {
  title: PropTypes.node,
  editing: PropTypes.bool,
  children: PropTypes.node,
  dataIndex: PropTypes.string,
  record: PropTypes.object,
  handleSave: PropTypes.func,
  getInstrumentItem: PropTypes.func,
  instrumentList: PropTypes.array,
  MAPPING_TYPE: PropTypes.array,
  assets: PropTypes.array,
};
